export const PARTNER_CURRENT_DATA_VEHICLE_RESULT = 'partner:currentDataVehicleResult'

export function setPartnerVehicleResult(data) {
  try {
    sessionStorage.setItem(PARTNER_CURRENT_DATA_VEHICLE_RESULT, JSON.stringify(data || {}))
  } catch (error) {}
}

export function getPartnerVehicleResult() {
  try {
    const raw = sessionStorage.getItem(PARTNER_CURRENT_DATA_VEHICLE_RESULT)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : null
  } catch (error) {
    return null
  }
}

export function clearPartnerVehicleResult() {
  try {
    sessionStorage.removeItem(PARTNER_CURRENT_DATA_VEHICLE_RESULT)
  } catch (error) {}
}
